<template>
  <div id="detalleSolicitudAMEX" :data-ready="printReady">
    <v-toolbar>
      <img src="@/assets/logo_javer.png" height="60" width="auto">
      <v-spacer></v-spacer>
      <v-toolbar-title>Detalle de solicitud AMEX</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-card-text>
      <v-container grid-list-md>
        <v-layout wrap>
          <v-flex xs6>
            <v-container>
              <h3 class="grey--text">Datos Generales</h3><br />
              <v-text-field v-model="solicitud.empresa" label="Empresa" disabled></v-text-field>
              <v-text-field v-model="solicitud.descripcion" label="Concepto" disabled></v-text-field>
              <v-text-field v-model="solicitud.centro_costo" label="Centro de costos" disabled></v-text-field>
              <v-text-field v-model="solicitud.direccion" label="UEN / Plaza" disabled></v-text-field>
              <v-text-field v-model="solicitud.departamento" label="Departamento" disabled></v-text-field>
              <br />
              <h3 class="grey--text">Información adicional</h3><br />
              <v-text-field v-model="solicitud.fecha_creacion" label="Fecha de solicitud" disabled></v-text-field>
              <v-text-field v-model="solicitud.solicitante" label="Solicitante" disabled></v-text-field>
              <v-text-field v-model="solicitud.estatus" label="Estatus" disabled></v-text-field>
            </v-container>
          </v-flex>
          <v-flex xs6>
            <v-container>
              <h3 class="grey--text">Datos de Pago</h3><br />
              <v-text-field v-model="solicitud.proveedor" label="Proveedor" disabled></v-text-field>
              <v-text-field v-model="solicitud.fecha_pago" label="Fecha de Pago" disabled></v-text-field>
              <v-text-field v-model="solicitud.saldo_a_pagar" label="Saldo a Pagar" prefix="$" suffix="MXN"
                disabled></v-text-field>
              <v-text-field v-model="solicitud.importe_comprobado" label="Importe Comprobado" prefix="$" suffix="MXN"
                disabled></v-text-field>
              <br />
              <h3 class="grey--text">FIRMAS DE APROBACIÓN</h3><br />
              <v-list three-line>
                <template v-for="(item, i) in firmasOperativas">
                  <v-list-tile class="pb-2 pt-2">
                    <v-list-tile-content>
                      <v-list-tile-title v-html="item.rol"></v-list-tile-title>
                      <v-list-tile-title v-html="item.nombre"></v-list-tile-title>
                      <v-list-tile-sub-title v-html="item.estado"></v-list-tile-sub-title>
                      <v-list-tile-sub-title v-show="item.estado !== 'En aprobación'"
                        v-html="item.fecha_actualizacion"></v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-divider v-show="(i + 1) < firmasOperativas.length"></v-divider>
                </template>
              </v-list>
              <template v-if="firmasDireccionGeneral.length > 0">
                <br />
                <h3 class="grey--text">APROBACIÓN DIRECCIÓN GENERAL</h3><br />
                <v-list three-line>
                  <template v-for="(item, i) in firmasDireccionGeneral">
                    <v-list-tile class="pb-2 pt-2">
                      <v-list-tile-content>
                        <v-list-tile-title v-html="item.rol"></v-list-tile-title>
                        <v-list-tile-title v-html="item.nombre"></v-list-tile-title>
                        <v-list-tile-sub-title v-html="item.estado"></v-list-tile-sub-title>
                        <v-list-tile-sub-title v-show="item.estado !== 'En aprobación'"
                          v-html="item.fecha_actualizacion"></v-list-tile-sub-title>
                      </v-list-tile-content>
                    </v-list-tile>
                    <v-divider v-show="(i + 1) < firmasDireccionGeneral.length"></v-divider>
                  </template>
                </v-list>
              </template>
            </v-container>
          </v-flex>
        </v-layout>
        <h3 class="grey--text">Estados de Cuenta Asociados</h3><br />
        <v-data-table :headers="headersEC" :items="estados_cuenta" :loading="loading" class="elevation-1" hide-actions>
          <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
          <template slot="items" slot-scope="{ item }">
            <tr>
              <td class="text-xs-center">{{ formatDateShort(item.fecha_corte) }}</td>
              <td class="text-xs-center">{{ formatDateShort(item.fecha_pago) }}</td>
              <td class="text-xs-center">{{ formatPeriodo(item.periodo) }}</td>
              <td class="text-xs-center">{{ item.tarjetahabiente }}</td>
              <td class="text-xs-center">{{ item.asistente }}</td>
              <td class="text-xs-center">{{ formatCurrency(item.saldo_a_pagar) }}</td>
            </tr>
          </template>
          <template slot="no-data">
            <div class="text-xs-center">No hay estados de cuenta asociados.</div>
          </template>
        </v-data-table>
      </v-container>
    </v-card-text>
  </div>
</template>

<script>
import services from '@/config/services'
import axios from 'axios'
import printReady from '@/utils/printReady'

// El rol se captura como texto libre en el flujo de aprobacion, asi que se
// normalizan acentos y mayusculas antes de identificar a Direccion General.
const esDireccionGeneral = (rol) => {
  if (!rol) return false
  const normalizado = rol
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toUpperCase()
    .replace(/\s+/g, ' ')
    .trim()
  return normalizado.indexOf('DIRECCION GENERAL') !== -1
}

export default {
  name: 'detalleSolicitudAMEX',
  mixins: [printReady],
  data: () => ({
    solicitud: {
      empresa: '',
      descripcion: '',
      centro_costo: '',
      direccion: '',
      departamento: '',
      fecha_creacion: '',
      solicitante: '',
      estatus: '',
      proveedor: '',
      fecha_pago: '',
      saldo_a_pagar: '0.00',
      importe_comprobado: '0.00',
    },
    firmas: [],
    estados_cuenta: [],
    headersEC: [
      { text: 'Fecha Corte', value: 'fecha_corte', sortable: false, class: 'text-xs-center' },
      { text: 'Fecha Pago', value: 'fecha_pago', sortable: false, class: 'text-xs-center' },
      { text: 'Periodo', value: 'periodo', sortable: false, class: 'text-xs-center' },
      { text: 'Tarjetahabiente', value: 'tarjetahabiente', sortable: false, class: 'text-xs-center' },
      { text: 'Asistente', value: 'asistente', sortable: false, class: 'text-xs-center' },
      { text: 'Saldo a Pagar', value: 'saldo_a_pagar', sortable: false, class: 'text-xs-center' },
    ],
    loading: false,
  }),
  mounted() {
    this.fetchSolicitud()
  },
  computed: {
    firmasDireccionGeneral() {
      return this.firmas.filter(f => esDireccionGeneral(f.rol))
    },
    firmasOperativas() {
      return this.firmas.filter(f => !esDireccionGeneral(f.rol))
    }
  },
  methods: {
    formatCurrency(val) {
      return new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(val || 0);
    },
    formatDateShort(date) {
      if (!date) return '';
      const d = new Date(date);
      const pad = (n) => n.toString().padStart(2, '0');
      return `${pad(d.getDate())}-${pad(d.getMonth() + 1)}-${d.getFullYear()}`;
    },
    formatDateTimeCDMX(date) {
      if (!date) return '';
      const d = new Date(date.toLocaleString('en-US', { timeZone: 'America/Mexico_City' }));
      const pad = (n) => n.toString().padStart(2, '0');
      return `${pad(d.getDate())}-${pad(d.getMonth() + 1)}-${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
    },
    formatPeriodo(periodo) {
      if (!periodo) return '';
      const ano = periodo.substring(0, 4);
      const mes = periodo.substring(4, 6);
      return `${mes}/${ano}`;
    },
    formatDateLong(date) {
      if (!date) return '';
      const meses = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];
      const d = new Date(date);
      const pad = (n) => n.toString().padStart(2, '0');
      const mes = meses[d.getMonth()];
      return `${pad(d.getDate())}-${mes}-${d.getFullYear()}`;
    },
    async fetchSolicitud() {
      this.loading = true;
      try {
        let idsolicitud_amex = this.$route.query.idsolicitud_amex;
        var token = this.$route.query.token;
        this.$session.start();
        this.$session.set('jwt', token);
        const jwt = this.$session.get('jwt');
        const headers = { Authorization: 'Bearer ' + jwt };
        const url = services.routes.amexSolicitudesDetalle.replace(
          ':idsolicitud_amex',
          idsolicitud_amex
        );
        const { data } = await axios.get(url, { headers });

        this.solicitud.empresa = data.empresa ? data.empresa.nombre : '';
        this.solicitud.descripcion = data.descripcion || '';
        this.solicitud.centro_costo = data.centro_costo ? data.centro_costo.nombre : '';
        this.solicitud.direccion = data.direccion ? data.direccion.nombre : '';
        this.solicitud.departamento = data.departamento ? data.departamento.nombre : '';
        this.solicitud.fecha_creacion = this.formatDateTimeCDMX(data.fecha_creacion);
        this.solicitud.solicitante = data.usuario_creacion
          ? `${data.usuario_creacion.nombre} (${data.usuario_creacion.puesto})`
          : '';
        this.solicitud.estatus = data.estatus ? data.estatus.nombre : '';
        this.solicitud.proveedor = data.estados_cuenta && data.estados_cuenta.length > 0
          ? data.estados_cuenta[0].proveedor
          : '';
        this.solicitud.fecha_pago = this.formatDateLong(data.fecha_pago);
        this.solicitud.saldo_a_pagar = data.saldo_a_pagar || '0.00';
        this.solicitud.importe_comprobado = data.importe_comprobado || '0.00';

        this.estados_cuenta = data.estados_cuenta || [];
        this.firmas = data.firmas || [];
        this.markPrintReady();
      } catch (err) {
        console.error('Error al cargar detalle:', err);
      } finally {
        this.loading = false;
      }
    },
  }
}
</script>
